const TheDarkHills = (props) => {
    return (
        <div className="lyrics eggshell">
            <h2>The Dark Hills</h2>
            <h4>Edwin Arlington Robinson</h4>
            <p>
            Dark hills at evening in the west,<br/>
Where sunset hovers like a sound<br/>
Of golden horns that sang to rest<br/>
Old bones of warriors under ground,<br/>
Far now from all the bannered ways<br/>
Where flash the legions of the sun,<br/>
You fade--as if the last of days<br/>
Were fading, and all wars were done.<br/>
            </p>
        </div>
    )
}
export default TheDarkHills;